import { useLocation } from "react-router-dom";

export const useQueryParams = () => {
  const { search } = useLocation();

  const query = new URLSearchParams(search);

  return Object.fromEntries(query.entries());
};
